<template>
    <v-card tile elevation="0">
        <v-card-title> Trailer: {{ trailer.Trailer }} </v-card-title>
        <v-card-subtitle v-if="totalUsage > 0">
            Usage: {{ totalUsage }} / {{ limits[trailer.NumAxles] }} ({{
                trailer.NumAxles
            }}
            axles)
        </v-card-subtitle>
        <v-card-text>
            <v-row>
                <v-col
                    v-for="compartment in compartments"
                    :key="compartment.compartment"
                >
                    Compartment {{ compartment.compartment }}:<br />
                    {{ getProductName(compartment.product) }}
                    <v-progress-linear
                        :value="
                            (compartment.usage / compartment.capacity) * 100
                        "
                        height="25"
                        :color="compartment.color"
                    >
                        <span>
                            {{ compartment.usage }}
                            / {{ compartment.capacity }}
                        </span>
                    </v-progress-linear>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import { assignProductsToCompartments } from '../../../mixins/trailerUtils';
export default {
    name: 'TrailerCompartments',
    props: ['trailer', 'orderDetails', 'products'],
    data() {
        return {
            limits: {
                6: 60000,
                5: 58000,
                4: 55000,
                3: 30000,
                1: 20000
            },
            colors: [
                'rgba(54, 162, 235)', // Blue
                'rgba(255, 159, 64)', // Orange
                'rgba(75, 192, 192)', // Green
                'rgba(255, 99, 132)', // Red
                'rgba(153, 102, 255)', // Purple
                'rgba(52, 73, 94)', // Dark Blue
                'rgba(255, 182, 193)', // Pink
                'rgba(255, 206, 86)' // Yellow
            ],
            productColorMap: {} // Will store colors assigned to ProductIds
        };
    },
    computed: {
        compartments() {
            const result = assignProductsToCompartments(
                this.orderDetails,
                this.trailer,
                this.limits,
                this.products
            );

            // Assign colors to compartments based on product
            result.compartments.forEach(compartment => {
                if (compartment.product) {
                    if (!this.productColorMap[compartment.product]) {
                        this.productColorMap[
                            compartment.product
                        ] = this.getProductColor(compartment.product);
                    }
                    compartment.color = this.productColorMap[
                        compartment.product
                    ];
                } else {
                    compartment.color = '#FFFFFF'; // Default color if empty
                }
                compartment.name = `Comp${compartment.compartment}`;
            });

            return result.compartments;
        },
        totalUsage() {
            const result = assignProductsToCompartments(
                this.orderDetails,
                this.trailer,
                this.limits,
                this.products
            );
            return result.totalUsage;
        }
    },
    methods: {
        // Returns a color based on the productId, ensuring a unique color per product
        getProductColor(productId) {
            const products = Object.keys(this.productColorMap);
            // Assign a new color for new product, reusing colors if there are more than the colors array length
            return this.colors[products.length % this.colors.length];
        },
        getProductName(productId) {
            const product = this.products.find(p => p.ProductID === productId);
            return product ? product.Product : null;
        }
    }
};
</script>
